export const imports = {
  'docs/Compatibility.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-compatibility" */ 'docs/Compatibility.mdx'
    ),
  'docs/GettingStarted.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-getting-started" */ 'docs/GettingStarted.mdx'
    ),
  'docs/Home.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-home" */ 'docs/Home.mdx'
    ),
  'docs/advanced/AddVariant.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-advanced-add-variant" */ 'docs/advanced/AddVariant.mdx'
    ),
  'docs/advanced/CustomComponent.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-advanced-custom-component" */ 'docs/advanced/CustomComponent.mdx'
    ),
  'docs/advanced/ExtendStyles.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-advanced-extend-styles" */ 'docs/advanced/ExtendStyles.mdx'
    ),
  'docs/advanced/Refs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-advanced-refs" */ 'docs/advanced/Refs.mdx'
    ),
  'docs/basics/Emotion.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-basics-emotion" */ 'docs/basics/Emotion.mdx'
    ),
  'docs/basics/Accessibility.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-basics-accessibility" */ 'docs/basics/Accessibility.mdx'
    ),
  'docs/basics/Forms.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-basics-forms" */ 'docs/basics/Forms.mdx'
    ),
  'docs/basics/Grid.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-basics-grid" */ 'docs/basics/Grid.mdx'
    ),
  'docs/basics/Normalize.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-basics-normalize" */ 'docs/basics/Normalize.mdx'
    ),
  'docs/basics/Theming.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-basics-theming" */ 'docs/basics/Theming.mdx'
    ),
  'docs/basics/Utilities.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-basics-utilities" */ 'docs/basics/Utilities.mdx'
    ),
  'docs/components/Alert.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-alert" */ 'docs/components/Alert.mdx'
    ),
  'docs/components/Box.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-box" */ 'docs/components/Box.mdx'
    ),
  'docs/components/Button.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-button" */ 'docs/components/Button.mdx'
    ),
  'docs/components/Checkbox.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-checkbox" */ 'docs/components/Checkbox.mdx'
    ),
  'docs/components/FormCheck.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-form-check" */ 'docs/components/FormCheck.mdx'
    ),
  'docs/components/Input.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-input" */ 'docs/components/Input.mdx'
    ),
  'docs/components/Modal.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-modal" */ 'docs/components/Modal.mdx'
    ),
  'docs/components/Popover.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-popover" */ 'docs/components/Popover.mdx'
    ),
  'docs/components/Radio.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-radio" */ 'docs/components/Radio.mdx'
    ),
  'docs/components/Select.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-select" */ 'docs/components/Select.mdx'
    ),
  'docs/components/Switch.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-switch" */ 'docs/components/Switch.mdx'
    ),
  'docs/components/Textarea.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-textarea" */ 'docs/components/Textarea.mdx'
    ),
  'docs/components/Tooltip.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-tooltip" */ 'docs/components/Tooltip.mdx'
    ),
  'docs/components/Typography.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-components-typography" */ 'docs/components/Typography.mdx'
    ),
  'docs/system/GettingStarted.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-system-getting-started" */ 'docs/system/GettingStarted.mdx'
    ),
  'docs/system/Props.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-system-props" */ 'docs/system/Props.mdx'
    ),
  'docs/system/Styled.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-system-styled" */ 'docs/system/Styled.mdx'
    ),
  'docs/system/Utilities.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-system-utilities" */ 'docs/system/Utilities.mdx'
    ),
  'docs/utilities/Breakpoint.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-utilities-breakpoint" */ 'docs/utilities/Breakpoint.mdx'
    ),
  'docs/utilities/SwitchState.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-utilities-switch-state" */ 'docs/utilities/SwitchState.mdx'
    ),
  'docs/utilities/Toggler.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-utilities-toggler" */ 'docs/utilities/Toggler.mdx'
    ),
}
